import { createFileRoute } from "@tanstack/react-router";
import { useRole } from "@/hooks/use-role";
import { PermissionDeniedPage } from "@/components/team/PermissionDeniedPage";
import { PhoneCreateFlow } from "@/components/phone-banking/PhoneCreateFlow";

export const Route = createFileRoute("/_app/_/phone-banking/new")({
	component: PhoneBankingNewPage,
});

function PhoneBankingNewPage() {
	const { isReadWrite } = useRole();
	if (!isReadWrite) {
		return (
			<PermissionDeniedPage
				requiredRole="Read/Write"
				message="You need Read/Write or Admin access to create a phone campaign."
			/>
		);
	}
	return (
		<div className="p-6">
			<PhoneCreateFlow />
		</div>
	)
}
